const APP_NAME = "YFlow Master";
const BRAND = "YFlow";
const VERSION = "0.0.1";
const BASE_URL = "https://master.yflow.io";

export { APP_NAME, BRAND, VERSION, BASE_URL };
